/* eslint-disable camelcase */
import { makeAutoObservable, set, toJS } from 'mobx'
import moment from 'moment'
import 'moment/locale/fr-ca'
import User from './User'
import Client from './Client'
import ClientsAddressesEquipment from './ClientsAddressesEquipment'
import FormEntry from './FormEntry'

moment.locale('fr-ca')

class Event {
  id = 0
  client_id = 0
  /**
   *
   * @type {Client}
   */
  client = null
  clients_addresses_equipment_id = 0
  /**
   *
   * @type {ClientsAddressesEquipment}
   */
  clients_addresses_equipment = null
  user_id = 0
  /**
   *
   * @type {User}
   */
  user = null
  no_inspection = 0
  completed_date = null

  date_end = null
  date_start = null
  starting_date = null
  submitted_date = null
  isConform = ''
  notes = ''
  created = null
  modified = null
  status = ''

  /** @type{array<FormEntry>} */
  forms_entries = []

  get statusName () {
    switch (this.status) {
      case 'CREATED':
        return "En attente d'inspection"
      case 'STARTED':
        return 'Débuté'
      case 'EXPIRED':
        return 'En retard'
      case 'WAITING_EVALUATION':
        return "En attente d'évaluation"
      case 'COMPLETED':
        return 'Terminé'
      case 'SCHEDULED':
        return 'Planifié non confirmé'
      default:
        return `N/A : ${this.status}`
    }
  }

  get conformStatus () {
    switch (this.isConform) {
      case 'conform':
        return 'Conforme'
      case 'conformWithException':
        return 'Conforme avec recommandation'
      case 'notConform':
        return 'Non Conforme'
      default:
        return `N/D ${this.isConform}`
    }
  }

  get readonly () {
    return this._readonly
  }

  get remainingTime () {
    if (this.status === Event.STATUS.CREATED) {
      return 'Non commencé'
    }
    if (this.status === Event.STATUS.STARTED) {
      const delay = moment(this.starting_date).diff(moment())
      if (delay > 0) {
        return moment.duration(delay).humanize()
      } else {
        return '24h terminé'
      }
    }
    return 'N/D'
  }

  constructor (data, readonly = false) {
    makeAutoObservable(this)
    if (data) {
      const { user, client, clients_addresses_equipment, forms_entries, ...rest } = data
      if (user) {
        this.user = new User()
        this.user.setOriginalData(data.user)
      }
      if (client) {
        this.client = new Client()
        this.client.setOriginalData(data.client)
      }
      if (clients_addresses_equipment) {
        this.clients_addresses_equipment = new ClientsAddressesEquipment()
        this.clients_addresses_equipment.setOriginalData(clients_addresses_equipment)
      }
      if (forms_entries) {
        for (const forms_entry of forms_entries) {
          this.forms_entries.push(new FormEntry(forms_entry, readonly))
        }
      }
      set(this, rest)
      this._readonly = readonly
    }
  }

  setSubmitDate (date) {
    this.submitted_date = date
  }

  toObject () {
    return toJS({
      id: this.id,
      submitted_date: this.submitted_date,
      isConform: this.isConform,
      notes: this.notes
    })
  }
}

Event.STATUS = {
  CREATED: 'CREATED',
  STARTED: 'STARTED',
  EXPIRED: 'EXPIRED',
  WAITING_EVALUATION: 'WAITING_EVALUATION',
  SCHEDULED: 'SCHEDULED',
  COMPLETED: 'COMPLETED'

}
export default Event
